import React from 'react';


const ContentVideo = ({path}) => (
  <div className="my-10 flex justify-center items-center">
    <iframe
      className="max-w-1000 w-full h-500px"
      src={path}
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  </div>
);

export default ContentVideo;
